<router-outlet />

<div #toastLayer toastContainer popover="manual" class="toast-top-layer" aria-live="polite"></div>
